<template>
  <div class="walletPage" id="walletPage" ref="walletPage">
    <TopBack :title="$t('lang.wallet.title')"/>

    <div class="page-body">
      <!-- 余额卡 -->
      <section class="card balance-card">
        <div class="bal-label">{{ $t('lang.wallet.availableBalance') }}</div>
        <div class="bal-amount-row">
          <span class="bal-amount">{{ separateThousandInteger(balance) }}</span>
          <span class="bal-unit">{{ $t('lang.account.currencyType') }}</span>
        </div>
        <div class="bal-approx">{{ $t('lang.wallet.approx', {amount: approxInr}) }}</div>

        <div class="bal-pill">
          <span class="pill-dot"></span>
          <span>{{ $t('lang.wallet.availableForPrograms', {amount: separateThousandInteger(availableForPrograms)}) }}</span>
        </div>

        <div class="bal-actions">
          <button class="btn-ghost" type="button" @click="onWithdraw">{{ $t('lang.wallet.withdraw') }}</button>
          <button class="btn-solid" type="button" @click="onAddFunds">{{ $t('lang.wallet.addFunds') }}</button>
        </div>
      </section>

      <!-- 流水 -->
      <section class="history">
        <h2 class="history-title">{{ $t('lang.wallet.history') }}</h2>

        <div class="filters">
          <button
            v-for="f in filters"
            :key="f.key"
            class="filter-pill"
            :class="{active: activeFilter === f.key}"
            type="button"
            @click="onFilter(f.key)">{{ $t(f.labelKey) }}</button>
        </div>

        <div class="tx-list">
          <div class="tx-item" v-for="(t, i) in transactions" :key="i">
            <div class="tx-left">
              <div class="tx-name-row">
                <span class="tx-name">{{ $t(t.typeKey) }}</span>
                <span class="tx-chip" v-if="t.statusKey">{{ $t(t.statusKey) }}</span>
              </div>
              <p class="tx-date">{{ t.date }}</p>
            </div>
            <div class="tx-amount" :class="t.positive ? 'pos' : 'neg'">
              {{ $t('lang.wallet.amountBc', {sign: t.positive ? '+' : '-', amount: separateThousandInteger(t.amount)}) }}
            </div>
          </div>
        </div>

        <div class="load-more-wrap">
          <button class="load-more" type="button" @click="onLoadMore">
            <svg viewBox="0 0 24 24" class="ic-down" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>{{ $t('lang.wallet.loadMore') }}</span>
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {separateThousandInteger} from '@/utils'
import TopBack from '@/components/TopBack/index'

export default {
  name: 'Wallet',
  components: {TopBack},
  data () {
    return {
      // 静态占位数据：文案与数值取自 Stitch screen 1f2d0f61 (Wallet)。
      // 后端钱包接口尚未提供，service/service2 不在本次改动范围；接口就绪后改为 mounted 请求并填充同名结构。
      balance: 12580,
      approxInr: '125.80',
      availableForPrograms: 900,
      activeFilter: 'all',
      filters: [
        {key: 'all', labelKey: 'lang.wallet.filterAll'},
        {key: 'addFunds', labelKey: 'lang.wallet.filterAddFunds'},
        {key: 'withdraw', labelKey: 'lang.wallet.filterWithdraw'},
        {key: 'rewards', labelKey: 'lang.wallet.filterRewards'},
        {key: 'program', labelKey: 'lang.wallet.filterProgram'}
      ],
      transactions: [
        {typeKey: 'lang.wallet.typeAddFunds', statusKey: 'lang.wallet.statusDone', date: 'Oct 28, 14:20', amount: 2000, positive: true},
        {typeKey: 'lang.wallet.typeProgramLocked', statusKey: null, date: 'Oct 27, 20:30', amount: 1000, positive: false},
        {typeKey: 'lang.wallet.typeWithdraw', statusKey: 'lang.wallet.statusProcessing', date: 'Oct 27, 19:40', amount: 5000, positive: false},
        {typeKey: 'lang.wallet.typeWithdrawalFee', statusKey: null, date: 'Oct 27, 19:40', amount: 50, positive: false},
        {typeKey: 'lang.wallet.typeCheckIn', statusKey: null, date: 'Oct 27, 12:00', amount: 200, positive: true},
        {typeKey: 'lang.wallet.typeProgramReturned', statusKey: null, date: 'Oct 24, 18:30', amount: 1000, positive: true}
      ]
    }
  },
  methods: {
    separateThousandInteger,
    onWithdraw () {
      // TODO: 进入提现流程
    },
    onAddFunds () {
      // TODO: 进入充值收银台
    },
    onFilter (key) {
      this.activeFilter = key
      // TODO: 按类型筛选流水
    },
    onLoadMore () {
      // TODO: 分页加载更多流水
    }
  }
}
</script>

<style lang='less' scoped>
.walletPage {
  position: relative;
  min-height: 100dvh;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: var(--stitch-page-bg);
}

.page-body {
  padding: calc(60vw / 3.6) calc(16vw / 3.6) calc(24vw / 3.6); /* 顶部 TopBack 占位 */
}

/* ---- 通用卡片 ---- */
.card {
  background: var(--stitch-surface);
  border: calc(1vw / 3.6) solid var(--stitch-wallet-card-border);
  border-radius: var(--stitch-radius-xl);
  box-shadow: 0 calc(1vw / 3.6) calc(2vw / 3.6) rgba(0, 0, 0, .05);
}

/* ---- 余额卡 ---- */
.balance-card { padding: calc(16vw / 3.6); }
.bal-label {
  font-size: calc(12vw / 3.6);
  font-weight: 500;
  letter-spacing: 0.025em;
  text-transform: uppercase;
  color: var(--stitch-text-secondary);
}
.bal-amount-row { margin-top: calc(4vw / 3.6); display: flex; align-items: baseline; gap: calc(6vw / 3.6); }
.bal-amount { font-size: calc(32vw / 3.6); font-weight: 700; letter-spacing: -0.025em; color: var(--stitch-text-primary); line-height: 1; }
.bal-unit { font-size: calc(20vw / 3.6); font-weight: 700; color: var(--stitch-brand); line-height: 1; }
.bal-approx { font-size: calc(14vw / 3.6); color: var(--stitch-text-secondary); margin-top: calc(4vw / 3.6); font-weight: 400; }

.bal-pill {
  margin-top: calc(12vw / 3.6);
  display: inline-flex;
  align-items: center;
  gap: calc(6vw / 3.6);
  background: var(--stitch-brand-soft);
  color: var(--stitch-brand);
  font-size: calc(12vw / 3.6);
  font-weight: 500;
  padding: calc(4vw / 3.6) calc(12vw / 3.6);
  border-radius: var(--stitch-radius-full);
}
.pill-dot { width: calc(6vw / 3.6); height: calc(6vw / 3.6); border-radius: var(--stitch-radius-full); background: var(--stitch-brand); flex-shrink: 0; }

.bal-actions { margin-top: calc(16vw / 3.6); display: grid; grid-template-columns: 1fr 1fr; gap: calc(12vw / 3.6); }
.btn-ghost, .btn-solid {
  height: calc(42vw / 3.6);
  border-radius: var(--stitch-radius-xl);
  font-weight: 600;
  font-size: calc(14vw / 3.6);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color .12s ease, opacity .12s ease;
  -webkit-tap-highlight-color: transparent;
}
.btn-ghost {
  background: var(--stitch-surface);
  border: calc(1.5vw / 3.6) solid var(--stitch-brand);
  color: var(--stitch-brand);
}
.btn-ghost:active { background: var(--stitch-brand-soft); }
.btn-solid {
  background: var(--stitch-brand);
  border: none;
  color: var(--stitch-surface);
  box-shadow: 0 calc(1vw / 3.6) calc(2vw / 3.6) rgba(0, 81, 223, .18);
}
.btn-solid:active { background: var(--stitch-brand-active); }

/* ---- 流水 ---- */
.history { margin-top: calc(20vw / 3.6); display: flex; flex-direction: column; }
.history-title { font-size: calc(16vw / 3.6); font-weight: 700; color: var(--stitch-text-primary); margin-bottom: calc(10vw / 3.6); }

.filters {
  display: flex;
  align-items: center;
  gap: calc(8vw / 3.6);
  overflow-x: auto;
  margin: 0 calc(-16vw / 3.6);
  padding: 0 calc(16vw / 3.6) calc(12vw / 3.6);
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.filters::-webkit-scrollbar { display: none; }
.filter-pill {
  flex-shrink: 0;
  background: var(--stitch-surface);
  border: calc(1vw / 3.6) solid var(--stitch-wallet-card-border);
  color: var(--stitch-text-secondary);
  font-size: calc(13vw / 3.6);
  font-weight: 500;
  padding: calc(6vw / 3.6) calc(14vw / 3.6);
  border-radius: var(--stitch-radius-full);
  cursor: pointer;
  transition: background-color .12s ease;
  -webkit-tap-highlight-color: transparent;
}
.filter-pill.active {
  background: var(--stitch-brand);
  border-color: var(--stitch-brand);
  color: var(--stitch-surface);
  padding: calc(6vw / 3.6) calc(16vw / 3.6);
}

.tx-list {
  background: var(--stitch-surface);
  border: calc(1vw / 3.6) solid var(--stitch-wallet-card-border);
  border-radius: var(--stitch-radius-xl);
  box-shadow: 0 calc(1vw / 3.6) calc(2vw / 3.6) rgba(0, 0, 0, .05);
  margin-top: calc(4vw / 3.6);
  overflow: hidden;
}
.tx-item {
  padding: calc(14vw / 3.6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: calc(1vw / 3.6) solid var(--stitch-wallet-divider);
}
.tx-item:last-child { border-bottom: none; }
.tx-left { min-width: 0; }
.tx-name-row { display: flex; align-items: center; gap: calc(8vw / 3.6); }
.tx-name { font-size: calc(14vw / 3.6); font-weight: 600; color: var(--stitch-text-primary); }
.tx-chip {
  background: var(--stitch-chip-bg);
  color: var(--stitch-text-secondary);
  font-size: calc(11vw / 3.6);
  font-weight: 500;
  padding: calc(2vw / 3.6) calc(8vw / 3.6);
  border-radius: var(--stitch-radius-full);
}
.tx-date { font-size: calc(12vw / 3.6); color: var(--stitch-text-secondary); margin-top: calc(2vw / 3.6); }
.tx-amount { font-size: calc(14vw / 3.6); font-weight: 700; text-align: right; white-space: nowrap; }
.tx-amount.pos { color: var(--stitch-brand); }
.tx-amount.neg { color: var(--stitch-text-primary); }

.load-more-wrap { display: flex; justify-content: center; margin: calc(20vw / 3.6) 0 calc(8vw / 3.6); }
.load-more {
  display: inline-flex;
  align-items: center;
  gap: calc(6vw / 3.6);
  background: var(--stitch-brand-soft);
  color: var(--stitch-brand);
  font-size: calc(13vw / 3.6);
  font-weight: 500;
  padding: calc(8vw / 3.6) calc(16vw / 3.6);
  border: none;
  border-radius: var(--stitch-radius-full);
  cursor: pointer;
  transition: background-color .12s ease;
  -webkit-tap-highlight-color: transparent;
}
.load-more:active { background: var(--stitch-icon-bg); }
.ic-down { width: calc(14vw / 3.6); height: calc(14vw / 3.6); flex-shrink: 0; }
</style>



// WEBPACK FOOTER //
// src/pages/Wallet/index.vue